import _defineProperty from "/home/ec2-user/workspace/nt-app_patient-app_release_1.5.0/master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/ec2-user/workspace/nt-app_patient-app_release_1.5.0/master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/ec2-user/workspace/nt-app_patient-app_release_1.5.0/master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/ec2-user/workspace/nt-app_patient-app_release_1.5.0/master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/ec2-user/workspace/nt-app_patient-app_release_1.5.0/master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/ec2-user/workspace/nt-app_patient-app_release_1.5.0/master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/ec2-user/workspace/nt-app_patient-app_release_1.5.0/master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import Masked from './base.js';
import IMask from '../core/holder.js';
import '../core/change-details.js';
import '../core/continuous-tail-details.js';
import '../core/utils.js';

/** Masking by custom Function */
var MaskedFunction = /*#__PURE__*/function (_Masked) {
  _inherits(MaskedFunction, _Masked);
  var _super = _createSuper(MaskedFunction);
  function MaskedFunction() {
    _classCallCheck(this, MaskedFunction);
    return _super.apply(this, arguments);
  }
  _createClass(MaskedFunction, [{
    key: "updateOptions",
    value: /** */

    /** Enable characters overwriting */

    /** */

    /** */

    function updateOptions(opts) {
      _get(_getPrototypeOf(MaskedFunction.prototype), "updateOptions", this).call(this, opts);
    }
  }, {
    key: "_update",
    value: function _update(opts) {
      _get(_getPrototypeOf(MaskedFunction.prototype), "_update", this).call(this, _objectSpread(_objectSpread({}, opts), {}, {
        validate: opts.mask
      }));
    }
  }]);
  return MaskedFunction;
}(Masked);
IMask.MaskedFunction = MaskedFunction;
export { MaskedFunction as default };